import React, { CSSProperties } from 'react';
import { createUseStyles } from 'react-jss';
import { colorsModeUI, MODE_UI_OPTIONS } from '../../../modeUI';
import {
  getTimeTicksAndLocation,
  TICKS_DENSITY_PX,
} from '../../util/getTimeTicks';
interface Props {
  widthVAxis?: number;
  width: number;
  mode?: MODE_UI_OPTIONS;
  /** date in unix notation */
  minDatetime: number;
  /** date in unix notation */
  maxDatetime: number;
  styleRight?: CSSProperties;
}
const useStyles = createUseStyles((theme: ReturnType<typeof colorsModeUI>) => ({
  container: {
    width: '100%',
    maxWidth: '100%',
    display: 'flex',
    'font-size': '10px',
    height: '32px',
    backgroundColor: theme.CONTROL_UNIT_DETAILS_BACKGROUND_COLOR,
    color: theme.INFORMATION_COLOR,
  },
  leftContainer: {
    minWidth: (props: Props) => props.widthVAxis,
    maxWidth: (props: Props) => props.widthVAxis,
  },
  ticksContainer: (props: Props) => {
    const { width } = props;
    return {
      marginLeft: props.widthVAxis,
      position: 'relative',
      width: width,
      lineHeight: 'initial',
    };
  },
  itemContainer: {
    maxWidth: TICKS_DENSITY_PX,
    lineHeight: 'initial',
    textAlign: 'center',
    position: 'absolute',
    top: '50%',
    '-ms-transform': 'translate(-50%, -50%)',
    transform: 'translate(-50%, -50%)',
    whiteSpace: 'break-spaces',
  },
}));

export function LabelsXAxisTime(props: Props) {
  const { mode, minDatetime, maxDatetime, width } = props;
  const classes = useStyles({ ...props, theme: colorsModeUI(mode) });

  const ticks = getTimeTicksAndLocation(minDatetime, maxDatetime, width);

  return (
    <div className={`LabelsXAxisTime ${classes.container}`}>
      <div className={`LabelsXAxisTime-ticks-container ${classes.ticksContainer}`}>
        {ticks.map((item, index) => (
          <div
            key={`${item.timeStamp}`}
            className={classes.itemContainer}
            style={{ left: item.pixelStart }}
          >
            {item.format}
          </div>
        ))}
      </div>
    </div>
  );
}
